import { useContext } from 'react';
import { RequestDelayContext } from 'contexts/request_delay_context';

const useRequestDelay = () => {
    return useContext(RequestDelayContext);
};

export default useRequestDelay;
